import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=65361eac"
import script from "./landing-page.vue?vue&type=script&lang=js"
export * from "./landing-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutCookieConsent: require('/builds/athlyzer-devs/athlyzer-website/components/layout/cookie-consent.vue').default,LandingPageHeader: require('/builds/athlyzer-devs/athlyzer-website/components/landing-page/header.vue').default,LayoutFooter: require('/builds/athlyzer-devs/athlyzer-website/components/layout/footer.vue').default})
